module.exports = __webpack_public_path__ + "img/Proliferation-CRC_10X_TGSP.4aebe38c.png";